// extracted by mini-css-extract-plugin
export default {"modalBody":"ContentFileModal_modalBody__xdDcr"};